import track from './track';

// this action if dispatched will generate an event in segement.io
// to set remarketing tags for the current user
const setRemarketingTag = (tags, { nonInteraction } = { nonInteraction: 1 }) =>
  track('User tagged for remarketing', { ...tags, nonInteraction });

export default setRemarketingTag;
